import { render, staticRenderFns } from "./emTeamDetail.vue?vue&type=template&id=28dcc7ca&scoped=true&"
import script from "./emTeamDetail.vue?vue&type=script&lang=js&"
export * from "./emTeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./emTeamDetail.vue?vue&type=style&index=0&id=28dcc7ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcc7ca",
  null
  
)

export default component.exports